import { createSelector } from 'reselect';
import { ApplicationState } from '../store';

import { ConditionOptionsType } from '~/constants/automationRuleForm';
import { ruleReprocessingStatus } from '~/constants/rules';
import AutomationRuleError from '~/types/AutomationRuleError';
import BusinessRule from '~/types/BusinessRule';

export const getAutomationsStore = (state: ApplicationState) => state.automations;
export const getFiltersStore = (state: ApplicationState) => state.filters;
export const getParcelTemplateStore = (state: ApplicationState) => state.parcelTemplate;

// returns array of package template object ids that have rules associated
export const getPackageTemplateIdsWithRules = createSelector(
  getAutomationsStore,
  (automationsStore): string[] => automationsStore.associatedPackageTemplateIds,
);

// returns rules except default, for use in custom rule section
export const getCustomRules = createSelector(
  getAutomationsStore,
  (automationsStore): BusinessRule[] => {
    return automationsStore.businessRules.filter((rule) => {
      return rule.rankDesc !== 0;
    });
  },
);

export const getDeleteRuleModalIsOpen = createSelector(
  getAutomationsStore,
  (automationsStore) => automationsStore.deleteRuleModalIsOpen,
);

export const getAddRuleModalIsOpen = createSelector(
  getAutomationsStore,
  (automationsStore) => automationsStore.addRuleModalIsOpen,
);

export const getAutomationRuleError = createSelector(
  getAutomationsStore,
  ({ error }): AutomationRuleError => error,
);

export const getReprocessRuleState = createSelector(
  getAutomationsStore,
  (automationsStore): string => automationsStore.reprocessRuleStatus,
);

export const isRuleReprocessingPending = createSelector(
  getAutomationsStore,
  (automationsStore): boolean =>
    automationsStore.reprocessRuleStatus === ruleReprocessingStatus.pending,
);

export const hasClosedReprocessingPendingNotification = createSelector(
  getAutomationsStore,
  (automationsStore): boolean => automationsStore.closedReprocessingPendingNotification,
);

export const hasClosedReprocessingCompleteNotification = createSelector(
  getAutomationsStore,
  (automationsStore): boolean => automationsStore.closedReprocessingCompleteNotification,
);

export const getDisabledConditionOptionsList = createSelector(
  getAutomationsStore,
  (automationsStore): ConditionOptionsType => automationsStore.disabledConditionOptionsList,
);
